import * as React from 'react';
import { useState } from 'react';
import { translate } from '@js/common/helpers';
import { useNotifyMe } from '../hooks/useNotifyMe';
import { buildGoogleCalendarUrl } from '../utils/calendarLink';
export function FollowButton(_a) {
    var event = _a.event, userEmail = _a.userEmail;
    var _b = useNotifyMe(event.slug, userEmail, function () {
        window.open(buildGoogleCalendarUrl(event), '_blank', 'noopener');
    }), status = _b.status, subscribed = _b.subscribed, toggle = _b.toggle;
    var _c = useState(false), hovered = _c[0], setHovered = _c[1];
    function getLabel() {
        if (status === 'pending') {
            return translate('calendar.notify_me_pending');
        }
        if (status === 'error') {
            return translate('calendar.notify_me_error');
        }
        if (!subscribed) {
            return translate('calendar.follow');
        }
        if (hovered) {
            return translate('calendar.unfollow');
        }
        return "\u2713 " + translate('calendar.following');
    }
    return (React.createElement("button", { type: "button", className: "btn-secondary show-card-follow show-card-follow--" + status, onClick: toggle, onMouseEnter: function () { return setHovered(true); }, onMouseLeave: function () { return setHovered(false); }, onFocus: function () { return setHovered(true); }, onBlur: function () { return setHovered(false); }, disabled: status === 'pending' }, getLabel()));
}
